<template>
  <v-card class="elevation-10">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title class="w-100">Доверенности</v-toolbar-title>

    </v-toolbar>
    <v-card-text>
      <v-data-table :headers="headers" :items="items" :loading="loading" class="custom-table" :options.sync="options" :server-items-length="totalItems" :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100] }">
        <template v-slot:no-data> Ничего не найдено</template>

        <template v-slot:item.actions="scope">
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn color="dark" icon v-on="on">
                <v-icon>{{ mdiDotsVertical }}</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item :to="{name: 'company-attorney-view', params: {id: scope.item.id}}">
                <v-list-item-title> Открыть доверенность</v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadSingle(scope.item)">
                <v-list-item-title> Скачать на excel</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:top>
          <v-row>
            <v-col cols="12" md="5">
              <v-text-field v-model="filters.search" label="Поиск" class="mx-4" @input="searchDebounce"/>
            </v-col>
            <v-col cols="12" md="5">
              <v-autocomplete v-model="filters.branch"
                              :items="$store.getters.useBranches"
                              item-value="id"
                              :item-text="item => {return `${item.name} (${item.ownerName})`}"
                              :clearable="true" label="Филиал" placeholder="Поиск"/>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn v-show="isShowButtonDownload" color="primary" small :loading="loadingExcel" @click="downloadAll"> Скачать на excel</v-btn>
            </v-col>
          </v-row>
        </template>

        <template v-slot:footer.page-text="item">
          <div class="d-inline-flex mr-7">
            <v-text-field label="Перейти на страницу" type="number" v-model="page"/>
          </div>
          <div class="d-inline-flex">
            {{ item.pageStart }} - {{ item.pageStop }} из {{ item.itemsLength }}
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import companyAttorney from "@/services/attorney.service"
import _ from 'underscore';
import {mdiDotsVertical} from '@mdi/js';
import {jsonDataToExcel} from "@/js/XLSX";
import moment from 'moment';
import AttorneyService from '@/services/attorney.service';

export default {
  name: "ContractionAttorneyView",
  data() {
    return {
      isShowButtonDownload: true,
      loadingExcel: false,
      mdiDotsVertical,

      headers: [
        {
          text: '#',
          value: 'rowNumber',
          sortable: false
        },
        {
          text: 'Ф.И.О',
          value: 'fullName',
          sortable: false
        },
        {
          text: 'Наименования контрагента',
          sortable: false,
          value: 'ownerName'
        },
        {
          text: 'Должность',
          sortable: false,
          value: 'position'
        },
        {
          text: 'Номер доверенность',
          sortable: false,
          value: 'number'
        },
        {
          text: 'Инн сотрудника',
          sortable: false,
          value: 'personInn'
        },
        {
          text: '',
          sortable: false,
          value: 'actions'
        }
      ],
      items: [],
      loading: false,
      totalItems: 0,
      filters: {
        search: '',
        branch: null
      },
      options: {
        sortBy: ['fullName'],
        sortDesc: [true]
      },
    }
  },
  computed: {
    searchBranch() {
      return this.filters.branch;
    },
    querySearch() {
      return this.$route.query.q ? this.$route.query.q : this.filters.search;
    },
    page: {
      get() {
        return +this.$route.query.page
      },
      set(value) {
        let setterValue = +value;
        let pages = this.totalItems ? Math.ceil(this.totalItems / this.limit) : 0;
        if (Number.isInteger(setterValue)) {
          if (setterValue < 1) {
            this.$set(this.options, 'page', 1);
          } else if (setterValue > pages) {
            this.$set(this.options, 'page', pages);
          } else {
            this.$set(this.options, 'page', setterValue);
          }
        } else {
          this.$set(this.options, 'page', 1);
        }
      }
    },
    limit() {
      return this.$route.query.limit;
    },
  },
  methods: {
    downloadSingle(item) {
      let vm = this;
      AttorneyService.getCompanyAttorney(item.id)
          .then(response => {
            let companyAttorney = {
              id: response.data.Id,
              ownerInn: response.data.OwnerInn,
              ownerName: response.data.OwnerName,
              number: response.data.Number,
              createdOn: moment(response.data.Number),
              start: moment(response.data.Start),
              end: moment(response.data.End),
              position: response.data.Position,
              fullName: response.data.Fullname,
              personInn: response.data.PersonInn,
              passportSerial: response.data.PassportSerial,
              passportNumber: response.data.PassportNumber,
              passportIssuer: response.data.PassportIssuer,
              passportIssuedOn: response.data.PassportIssuedOn ? moment(response.data.PassportIssuedOn) : null,
              contractorInn: response.data.ContractorInn,
              contractorName: response.data.ContractorName,
              contractNumber: response.data.ContractNumber,
              contractDate: response.data.ContractDate ? moment(response.data.ContractDate) : null,
              isSigned: response.data.IsSign,
              signedOn: response.data.SignedOn ? moment(response.data.SignedOn) : null,
              signedCertificateSerial: response.data.SignedCertificateSerial,
              items: _.map(response.data.Items, i => {
                return {
                  id: i.Id,
                  product: i.Product,
                  measurement: i.Measurement,
                  quantity: i.Quantity
                };
              })
            };

            let dataExcel = _.map(companyAttorney.items, function (item) {
              return {
                'Ф.И.О': companyAttorney.fullName,
                'Наименования контрагента': companyAttorney.ownerName,
                'Инн сотрудника': companyAttorney.ownerInn,
                'Должность': companyAttorney.position,
                'Номер доверенность': companyAttorney.number,
                'Инн сотрудника': companyAttorney.personInn,
                'Создан': companyAttorney.createdOn ? moment(companyAttorney.createdOn).format('YYYY.MM.DD') : '',
                'Дата выдачи': companyAttorney.start ? moment(companyAttorney.start).format('YYYY.MM.DD') : '',
                'Доверенность действительна по': companyAttorney.end ? moment(companyAttorney.end).format('YYYY.MM.DD') : '',
                'Пасспорт серия': companyAttorney.passportSerial,
                'Пасспорт номер': companyAttorney.passportNumber,
                'Кем выдан': companyAttorney.passportIssuer,
                'Дата выдачи': companyAttorney.passportIssuedOn,
                'Инн контрагента': companyAttorney.contractorInn,
                'Наименования контрагента': companyAttorney.contractorName,
                'Номер контракта': companyAttorney.contractNumber,
                'Дата контракта': companyAttorney.contractDate,
                'Товар': item.product,
                'Единица измерения': item.measurement,
                'Количество': item.quantity,
              }
            });

            jsonDataToExcel(dataExcel);
          })
          .finally(() => {
            vm.loading = false;
          });

    },
    downloadAll() {
      let vm = this;
      vm.loadingExcel = true;
      companyAttorney.getContractionAttorney({
        skip: null,
        limit: null,
        sortBy: null,
        desc: true,
        ownerInn: "",
        isActive: null,
        q: '',
        number: null,
        branch: null
      })
          .then(function (response) {
            let itemsList = _.map(response.data.Records, function (attorney, index) {
              return {
                rowNumber: index + 1,
                id: attorney.Id,
                ownerName: attorney.OwnerName,
                createdOn: attorney.CreatedOn,
                number: attorney.Number,
                start: attorney.Start,
                end: attorney.End,
                position: attorney.Position,
                fullName: attorney.Fullname,
                personInn: attorney.PersonInn,
                passportSerial: attorney.PassportSerial,
                passportNumber: attorney.PassportNumber,
                passportIssuer: attorney.PassportIssuer,
                passportIssuedOn: attorney.PassportIssuedOn,
                contractorInn: attorney.ContractorInn,
                contractorName: attorney.ContractorName,
                contractNumber: attorney.ContractNumber,
                contractDate: attorney.ContractDate
              };
            });
            let dataExcel = _.map(itemsList, function (item) {
              return {
                'Ф.И.О': item.fullName,
                'Наименования контрагента': item.ownerName,
                'Должность': item.position,
                'Номер доверенность': item.number,
                'Инн сотрудника': item.personInn,
                'Создан': item.createdOn ? moment(item.createdOn).format('YYYY.MM.DD') : '',
                'Дата выдачи': item.start ? moment(item.start).format('YYYY.MM.DD') : '',
                'Доверенность действительна по': item.end ? moment(item.end).format('YYYY.MM.DD') : '',
                'Пасспорт серия': item.passportSerial,
                'Пасспорт номер': item.passportNumber,
                'Кем выдан': item.passportIssuer,
                'Дата выдачи': item.passportIssuedOn,
                'Инн контрагента': item.contractorInn,
                'Наименования контрагента': item.contractorName,
                'Номер контракта': item.contractNumber,
                'Дата контракта': item.contractDate,
              }
            });
            jsonDataToExcel(dataExcel);
            vm.loadingExcel = false;
          })
          .finally(function () {
            vm.loadingExcel = false;
            vm.loading = false;
          });
    },

    searchDebounce: _.debounce(function () {
      this.$set(this.options, 'page', 1);

      this.updateRouteQuery({
        q: this.filters.search,
        page: this.page,
        limit: this.limit,
        branch: this.filters.branch
      });
    }, 500),

    loadContractionAttorney() {
      let vm = this;
      vm.loading = true;

      const {sortBy, sortDesc, page, itemsPerPage} = vm.options;
      const {search, branch} = vm.filters;

      let perPage = itemsPerPage ? itemsPerPage : 10;
      let queryPage = page ? page : 1;

      let skip = (queryPage - 1) * perPage;
      skip = skip < 0 ? 0 : skip;

      companyAttorney.getContractionAttorney({
        skip: skip,
        limit: perPage <= 0 ? null : perPage,
        sortBy: sortBy.length === 1 ? sortBy[0] : "",
        desc: sortDesc.length === 1 ? sortDesc[0] : false,
        ownerInn: "",
        isActive: null,
        q: search ? search : '',
        number: null,
        branch: branch
      })
          .then(function (response) {
            vm.totalItems = response.data.Total;
            let rowNumber = skip;
            vm.items = _.map(response.data.Records, attorney => {
              return {
                rowNumber: ++rowNumber,
                id: attorney.Id,
                ownerName: attorney.OwnerName,
                createdOn: attorney.CreatedOn,
                number: attorney.Number,
                start: attorney.Start,
                end: attorney.End,
                position: attorney.Position,
                fullName: attorney.Fullname,
                personInn: attorney.PersonInn,
                passportSerial: attorney.PassportSerial,
                passportNumber: attorney.PassportNumber,
                passportIssuer: attorney.PassportIssuer,
                passportIssuedOn: attorney.PassportIssuedOn,
                contractorInn: attorney.ContractorInn,
                contractorName: attorney.ContractorName,
                contractNumber: attorney.ContractNumber,
                contractDate: attorney.ContractDate
              };
            });
          })
          .finally(function () {
            vm.loading = false;
          });
    },
    updateRouteQuery({q, page, limit, branch}) {
      let query = {
        q: q,
        page: page,
        limit: limit,
        branch: branch
      };
      if (this.$route.query.q !== q
          || +this.$route.query.page !== +page
          || this.$route.query.branch !== branch
          || +this.$route.query.limit !== +limit) {
        this.$router.replace({name: this.$route.name, query: query});
      } else {
        this.loadContractionAttorney();
      }
    }
  },
  watch: {
    options: {
      handler() {
        let {page, itemsPerPage} = this.options;
        this.updateRouteQuery({
          q: this.querySearch,
          page: page,
          limit: itemsPerPage,
          branch: this.filters.branch
        });
      },
      deep: true,
    },
    $route: function () {
      this.loadContractionAttorney();
    },
    searchBranch() {
      this.updateRouteQuery({
        q: this.querySearch,
        page: this.page,
        limit: this.limit,
        branch: this.filters.branch ? this.filters.branch : null
      });
    },
  },
  created() {
    if (this.$route.query.limit) {
      this.$set(this.options, 'itemsPerPage', +this.$route.query.limit);
    }
    if (this.$route.query.page) {
      this.$set(this.options, 'page', +this.$route.query.page);
    }

    if (this.$route.query.branch) {
      this.filters.branch = +this.$route.query.branch;
    }

    this.filters.search = this.querySearch;
  }
}
</script>
